import React, { forwardRef } from "react";
import Input from "../form/input/InputField";
import Label from "../form/Label";

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
  errorMessage?: string;
}

const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, required, errorMessage, className, ...rest }, ref) => {
    return (
      <div>
        <Label>
          {label} {required && <span className="text-error-500">*</span>}
        </Label>
        <Input
          ref={ref}
          className={className}
          {...rest}
        />
        {errorMessage && (
          <p className="mt-1 text-sm text-error-500">{errorMessage}</p>
        )}
      </div>
    );
  }
);

export default FormField; 